module.exports = __webpack_public_path__ + "static/img/check8.23d4b679.jpg";